export default {
  metadata: {
    version: '1.0.0',
    id: 'date-picker-header-1.0.0',
    name: 'JDSDatepickerHeader'
  },
  hierarchy: {
    container: [
      'left-jds_button',
      {
        'inner-container': [
          'month-jds_datepicker_button',
          'year-jds_datepicker_button'
        ]
      },
      'right-jds_button'
    ]
  },
  base: {
    container: {
      width: '{d_0}',
      height: '{d_1}',
      'flex-direction': '{d_2}',
      'justify-content': '{d_3}',
      'align-items': '{d_4}'
    },
    'inner-container': {
      height: '{d_5}',
      'flex-direction': '{d_6}',
      'justify-content': '{d_7}',
      'align-items': '{d_8}',
      gap: '{d_9}',
      flex: 1
    },
    'left-jds_button': {
      hidden: false,
      kind: 'tertiary',
      icon: 'ic_chevron_left',
      size: 'medium'
    },
    'right-jds_button': {
      hidden: false,
      kind: 'tertiary',
      icon: 'ic_chevron_right',
      size: 'medium'
    },
    'month-jds_datepicker_button': {
      state: 'default'
    },
    'year-jds_datepicker_button': {
      state: 'default'
    }
  },
  variant: {
    state: {
      month: {
        'month-jds_datepicker_button': {
          state: 'selected'
        }
      },
      year: {
        'year-jds_datepicker_button': {
          state: 'selected'
        }
      }
    },
    showArrows: {
      false: {
        'left-jds_button': {
          hidden: true
        },
        'right-jds_button': {
          hidden: true
        }
      }
    },
    monthSelectable: {
      false: {
        'month-jds_datepicker_button': {
          state: 'disabled'
        }
      }
    },
    yearSelectable: {
      false: {
        'year-jds_datepicker_button': {
          state: 'disabled'
        }
      }
    }
  },
  combination: [
    {
      false: {
        false: {
          'month-jds_datepicker_button': {
            state: 'text_only'
          },
          'year-jds_datepicker_button': {
            state: 'text_only'
          }
        }
      }
    }
  ],
  combination_config: [['monthSelectable', 'yearSelectable']],
  api: {
    config: {
      state: {
        values: ['default', 'month', 'year']
      },
      showArrows: {
        values: [true, false]
      },
      monthSelectable: {
        values: [true, false]
      },
      yearSelectable: {
        values: [true, false]
      }
    },
    data: {
      'month-jds_datepicker_button': {
        text: {
          type: 'string',
          name: 'month'
        }
      },
      'year-jds_datepicker_button': {
        text: {
          type: 'string',
          name: 'year'
        }
      }
    },
    events: {
      'left-jds_button': {
        onClick: 'onPrev'
      },
      'month-jds_datepicker_button': {
        onClick: 'onMonthClick'
      },
      'year-jds_datepicker_button': {
        onClick: 'onYearClick'
      },
      'right-jds_button': {
        onClick: 'onNext'
      }
    },
    a11y: {
      'left-jds_button': {
        properties: {
          ariaLabel: {
            name: 'previousAriaLabel',
            value: 'Navigate to previous month'
          }
        }
      },
      'right-jds_button': {
        properties: {
          ariaLabel: {
            name: 'nextAriaLabel',
            value: 'Navigate to next month'
          }
        }
      },
      'month-jds_datepicker_button': {
        properties: {
          ariaLabel: {
            name: '_monthAriaLabel'
          }
        }
      },
      'year-jds_datepicker_button': {
        properties: {
          ariaLabel: {
            name: '_yearAriaLabel'
          }
        }
      }
    }
  }
};
